import { Fragment, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { IoCloseCircle, IoClose } from "react-icons/io5";

export default function ModalPopUp({ open, setOpen, URLs, handleRemoveURL, nudgeTitle, type }) {
  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={setOpen}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto mt-5">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative w-full max-w-lg p-6 transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all">
                <div className="flex justify-between items-center pb-4 border-b border-gray-200">
                  <h1 className="text-2xl font-medium">{nudgeTitle}</h1>
                  <IoClose onClick={() => setOpen(false)} className="text-2xl cursor-pointer" />
                </div>
                <p className="mt-2 mb-4 text-gray-600">{type}</p>
                <div className="overflow-y-auto max-h-80">
                  {URLs.length ? (
                    <div className="space-y-2">
                      {URLs.map((URL, key) => {
                        if (URL === "HandleEmptyArrayValue") return null;
                        return (<div key={key} className="flex items-center justify-between bg-gray-100 p-2 rounded-md hover:bg-gray-300">
                        <p className="break-words" style={{ width:"95%" }}>{URL}</p>
                        <IoCloseCircle
                          className="cursor-pointer text-red-500"
                          style={{ fontSize: '1.3rem' }}
                          onClick={() => handleRemoveURL(key)}
                        />
                      </div>)
                      })}
                    </div>
                  ) : (
                    <div className="flex items-center justify-center h-full">
                      <h1 className="text-xl">No {type} Added</h1>
                    </div>
                  )}
                </div>
                <div className="mt-4 flex justify-end">
                  <button
                    type="button"
                    className="inline-flex justify-center rounded-md border border-transparent bg-gray-700 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
                    onClick={() => setOpen(false)}
                  >
                    Cancel
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}


export function ModalPopUp2({ open, setOpen, URLs, handleRemoveURL, nudgeTitle, type }) {
  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={setOpen}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto mt-5">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative w-full max-w-lg p-6 transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all">
                <div className="flex justify-between items-center pb-4 border-b border-gray-200">
                  <h1 className="text-2xl font-medium">{nudgeTitle}</h1>
                  <IoClose onClick={() => setOpen(false)} className="text-2xl cursor-pointer" />
                </div>
                {/* <p className="mt-2 mb-4 text-gray-600">{type}</p> */}
                <div className="overflow-y-auto max-h-80">
                  {URLs && Object.keys(URLs).length ? (
                    <div className="space-y-4">
                      {Object.entries(URLs).map(([bucketKey, bucketData], bucketIndex) => {
                        if (!bucketData || bucketData.length === 0) return null;

                        return (
                          <div key={bucketIndex}>
                            <h2 className="text-lg font-semibold text-gray-700 mb-1">{bucketKey}</h2>
                            <div className="space-y-2">
                              {bucketData.map((URL, key) => {
                                if (URL === "HandleEmptyArrayValue") return null;
                                return (
                                  <div
                                    key={`${bucketIndex}-${key}`}
                                    className="flex items-center justify-between bg-gray-100 p-2 rounded-md hover:bg-gray-300"
                                  >
                                    <p className="break-words" style={{ width: "95%" }}>{URL}</p>
                                    <IoCloseCircle
                                      className="cursor-pointer text-red-500"
                                      style={{ fontSize: '1.3rem' }}
                                      onClick={() => handleRemoveURL(bucketKey, key)}
                                    />
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  ) : (
                    <div className="flex items-center justify-center h-full">
                      <h1 className="text-xl">No URLs Added</h1>
                    </div>
                  )}
                </div>
                <div className="mt-4 flex justify-end">
                  <button
                    type="button"
                    className="inline-flex justify-center rounded-md border border-transparent bg-gray-700 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
                    onClick={() => setOpen(false)}
                  >
                    Cancel
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}

export function ModalPopUpForSeoKeywords({ open, setOpen, keywords, handleRemoveKeyword, nudgeTitle, type }) {
  console.log("Keywords in ModalPopUpForSeoKeywords:", keywords);
  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={setOpen}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>
        <div className="fixed inset-0 z-10 overflow-y-auto mt-5">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative w-full max-w-3xl p-6 transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all">
                <div className="flex justify-between items-center pb-1 border-b border-gray-200">
                  <h1 className="text-2xl font-medium">{nudgeTitle}</h1>
                  <IoClose onClick={() => setOpen(false)} className="text-2xl cursor-pointer" />
                </div>
                <p className="mt-2 mb-3 text-gray-600">{type}</p>
                <div className="overflow-y-auto max-h-96">
                  {keywords && keywords.length > 0 ? (
                    <div className="space-y-4">
                      {keywords.map((keywordData,index) => (
                        <div
                          key={index}
                          className="border border-gray-200 rounded-lg p-4 bg-gray-50"
                        >
                          <div className="flex items-center justify-between mb-1">
                            <h3 className="text-lg font-semibold text-gray-800">
                              {keywordData.keyword}
                            </h3>
                            <IoCloseCircle
                              className="cursor-pointer text-red-500 hover:text-red-700"
                              style={{ fontSize: '1.5rem' }}
                              onClick={() => handleRemoveKeyword(index)}
                              title="Remove keyword"
                            />
                          </div>
                          
                          {keywordData.urls && keywordData.urls.length > 0 ? (
                            <div className="space-y-2">
                              <p className="text-sm text-gray-600 font-medium">
                                URLs ({keywordData.urls.length}):
                              </p>
                              <div className="max-h-40 overflow-y-auto space-y-1">
                                {keywordData.urls.map((url, urlIndex) => (
                                  <div
                                    key={urlIndex}
                                    className="bg-white p-2 rounded border text-sm break-all"
                                  >
                                    <a
                                      href={url}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="text-blue-600 hover:text-blue-800 hover:underline"
                                    >
                                      {url}
                                    </a>
                                  </div>
                                ))}
                              </div>
                            </div>
                          ) : (
                            <p className="text-sm text-gray-500 italic">No URLs found for this keyword</p>
                          )}
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="flex items-center justify-center h-32">
                      <h1 className="text-xl text-gray-500">No Keywords Added</h1>
                    </div>
                  )}
                </div>
                <div className="mt-6 flex justify-end">
                  <button
                    type="button"
                    className="inline-flex justify-center rounded-md border border-transparent bg-gray-700 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
                    onClick={() => setOpen(false)}
                  >
                    Close
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
